/* Native Shopify commerce and progressively enhanced V5 interactions. */
(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let variants = [], selected = null, review = 0, userPaused = false;
  let rotationTimer, observer, aborter, busy = false;
  const rootPath = () => window.Shopify?.routes?.root || '/';
  function openDialog(dialog) {
    if (!dialog) return;
    $$('video').forEach(v => v.pause());
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  }
  function showReview(index) {
    const slides = $$('.review-slide');
    if (!slides.length) return;
    review = (index + slides.length) % slides.length;
    slides.forEach((s, i) => { s.hidden = i !== review; s.setAttribute('aria-label', `Review ${i + 1} of ${slides.length}`); });
    if ($('#review-count')) $('#review-count').textContent = `${review + 1} / ${slides.length}`;
  }
  function rotate() {
    clearInterval(rotationTimer);
    const carousel = $('.mini-reviews');
    if (userPaused || document.hidden || reduced.matches || !carousel || carousel.matches(':hover') || carousel.contains(document.activeElement)) return;
    if ($$('.review-slide').length > 1) rotationTimer = setInterval(() => showReview(review + 1), 4500);
  }
  function selectVariant(id) {
    selected = variants.find(v => String(v.id) === String(id)) || variants[0];
    if (!selected) return;
    $$('input[name="seed-edition"]', $('#seed-v5-product-form')).forEach(input => {
      input.checked = String(input.value) === String(selected.id);
      input.closest('.variant')?.classList.toggle('selected', input.checked);
    });
    const variantInput = $('#seed-v5-product-form input[name="id"]');
    if (variantInput) {
      variantInput.value = selected.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const storePayments = $('.seed-store-payments');
    if (storePayments) storePayments.hidden = !selected.available;
    $$('.selected-price').forEach(e => { e.textContent = selected.money.replace(/<[^>]+>/g, ''); });
    if ($('#sticky-edition')) $('#sticky-edition').textContent = selected.name;
    $$('.add-bag').forEach(b => { b.disabled = !selected.available || busy; });
    const url = new URL(location.href); url.searchParams.set('variant', selected.id);
    history.replaceState(null, '', url);
  }
  function showGallery(button) {
    const thumb = $('img', button), image = $('.zoom-button img');
    if (!thumb || !image) return;
    image.src = thumb.currentSrc || thumb.src;
    image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.alt = thumb.alt;
    $$('.thumbs button').forEach(b => { b.classList.toggle('active', b === button); b.setAttribute('aria-pressed', String(b === button)); });
  }
  function enlarge(button) {
    const image = $('img', button);
    if (!image || !$('#expanded-image')) return;
    $('#expanded-image').src = image.currentSrc || image.src;
    $('#expanded-image').alt = image.alt;
    $('#image-caption').textContent = image.alt || 'Product details';
    openDialog($('#image-dialog'));
  }
  async function addToCart(form) {
    if (busy || !selected?.available) return;
    busy = true; $$('.add-bag').forEach(b => { b.disabled = true; });
    const status = $('#cart-status'); if (status) status.textContent = 'Adding to your bag…';
    try {
      const response = await fetch(rootPath() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      if (status) status.textContent = 'Added to your bag.';
      const content = $('#bag-content');
      if (content) {
        content.replaceChildren();
        const label = document.createElement('p'); label.textContent = `${selected.name} · ${selected.money.replace(/<[^>]+>/g, '')}`;
        content.append(label);
      }
      openDialog($('#bag-dialog'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: result }));
    } catch (error) {
      if (status) { status.textContent = error.message; status.classList.add('seed-cart-error'); }
    } finally {
      busy = false; $$('.add-bag').forEach(b => { b.disabled = !selected?.available; });
    }
  }
  function init() {
    aborter?.abort(); aborter = new AbortController(); const signal = aborter.signal;
    observer?.disconnect(); clearInterval(rotationTimer);
    const data = $('#product-data');
    if (data) {
      const product = JSON.parse(data.textContent); variants = product.variants;
      const requested = new URL(location.href).searchParams.get('variant');
      selectVariant(variants.some(v => String(v.id) === requested) ? requested : product.selected);
    }
    document.addEventListener('change', event => {
      if (event.target.matches('#seed-v5-product-form input[name="seed-edition"]')) selectVariant(event.target.value);
    }, { signal });
    document.addEventListener('submit', event => {
      if (event.target.id !== 'seed-v5-product-form') return;
      event.preventDefault(); addToCart(event.target);
    }, { signal });
    document.addEventListener('click', event => {
      const button = event.target.closest('button'); if (!button) return;
      if (button.matches('[data-select]')) {
        const variant = variants[Number(button.dataset.select)];
        if (variant) selectVariant(variant.id);
        $('#choose')?.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth' });
      }
      if (button.matches('[data-gallery]')) showGallery(button);
      if (button.matches('[data-image]')) enlarge(button);
      if (button.matches('.close')) button.closest('dialog')?.close();
      if (button.id === 'review-prev') { showReview(review - 1); rotate(); }
      if (button.id === 'review-next') { showReview(review + 1); rotate(); }
      if (button.id === 'review-pause') {
        userPaused = !userPaused; button.textContent = userPaused ? '▶' : 'Ⅱ';
        button.setAttribute('aria-label', userPaused ? 'Resume review rotation' : 'Pause review rotation'); rotate();
      }
    }, { signal });
    $$('dialog').forEach(dialog => {
      dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; }, { signal });
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      }, { signal });
    });
    const carousel = $('.mini-reviews'); let startX = 0, startY = 0;
    if (carousel) {
      ['mouseenter', 'mouseleave', 'focusin', 'focusout'].forEach(type => carousel.addEventListener(type, rotate, { signal }));
      carousel.addEventListener('pointerdown', e => { startX = e.clientX; startY = e.clientY; clearInterval(rotationTimer); }, { signal });
      carousel.addEventListener('pointerup', e => {
        const dx = e.clientX - startX, dy = e.clientY - startY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) showReview(review + (dx < 0 ? 1 : -1));
        rotate();
      }, { signal });
      carousel.addEventListener('pointercancel', rotate, { signal });
      carousel.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); showReview(review + (e.key === 'ArrowRight' ? 1 : -1)); rotate(); }
      }, { signal });
    }
    showReview(review); rotate();
    document.addEventListener('visibilitychange', () => { rotate(); if (document.hidden) $$('video').forEach(v => v.pause()); }, { signal });
    reduced.addEventListener('change', rotate, { signal });
    const sticky = $('.sticky-buy'), hero = $('.hero'), buy = $('#seed-v5-product-form .add-bag');
    let heroVisible = true, buyVisible = false;
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === buy) buyVisible = entry.isIntersecting;
        if (entry.target.tagName === 'VIDEO' && !entry.isIntersecting) entry.target.pause();
      });
      if (sticky) sticky.hidden = heroVisible || buyVisible || !selected;
    });
    if (hero) observer.observe(hero); if (buy) observer.observe(buy);
    $$('video').forEach(video => {
      observer.observe(video);
      video.addEventListener('play', () => { $$('video').forEach(other => { if (other !== video) other.pause(); }); }, { signal });
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => { clearInterval(rotationTimer); observer?.disconnect(); });
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('.review-slide');
    if (slide) { userPaused = true; showReview($$('.review-slide').indexOf(slide)); rotate(); }
  });
})();
